import { type StatsigClient } from '@statsig/react-bindings';

let client: StatsigClient;

export const setStatsigClient = (statsigClient: StatsigClient) => {
  client = statsigClient;
  return client;
};

export const getStatsigClient = () => client;
